import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { FindHttpError } from '../error/find-http-error';

@Injectable()
export class AccessoryService {
  private ACCESSORY_END_POINT = '/accessory';

  constructor(private httpService: HttpService) { }

  getAccessoryTypes() {
    return this.httpService.get(`${this.ACCESSORY_END_POINT}/getAccessoryTypes`, Array, FindHttpError);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/accessory.service.ts